const alphanumeric = (): {
  alphanumericFormat: RegExp;
  alphanumericValidationMessage: string;
} => ({
  alphanumericFormat: /^[A-Za-z0-9.,+!?&%$£*<>`'"@()[\]\\_\- /]*$/,
  alphanumericValidationMessage:
    'The field must only contain alphanumeric characters.',
});

export default alphanumeric;
